/* omn-panel-buybox.js — behaviour for snippets/omn-panel-buybox.liquid (Uniq Creative, Oct 2026).
 *
 * Bath panels for Omnitub customers only, cut to the bath with 100 mm of margin on each side for
 * adjustment (bath + 200 mm in every dimension). The bath comes from the basket (sizes rendered server-side from the tub's
 * specification metafields); with no tub, or "a different Omnitub", the customer types the
 * bath's size. Price = base + £80/m² of cut panel + £275 for any colour — the same formula the
 * panel-price Cart Transform enforces at checkout from the _omn_panel_* properties.
 */
(function () {
  'use strict';

  function money(pence) {
    var s = ((Number(pence) || 0) / 100).toFixed(2).split('.');
    s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '£' + s.join('.');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function track(name, data) {
    try {
      var p = Object.assign({ event: name }, data || {});
      if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(p);
      if (typeof window.omnEvent === 'function') window.omnEvent(name, p);
    } catch (e) {}
  }
  function int(v) { var n = parseInt(String(v == null ? '' : v).replace(/[^\d]/g, ''), 10); return isNaN(n) ? 0 : n; }

  /* Bath limits for the typed fallback (mm). */
  var LIM = { len: [600, 2200], wid: [500, 1600], hgt: [300, 1300] };
  var KIND_LABEL = { 'front': 'Front panel', 'l-left': 'L-shaped panel (left-handed)', 'l-right': 'L-shaped panel (right-handed)' };

  function init(root) {
    if (root.__opb) return;
    root.__opb = true;
    var C;
    try { C = JSON.parse(root.querySelector('[data-opb-config]').textContent); } catch (e) { return; }
    var $ = function (sel) { return root.querySelector(sel); };
    var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
    var TUBS = C.tubs || [];
    var M = C.marginTotal || 200;      /* added to each dimension: margin on both sides */
    var MS = C.margin || 100;         /* margin on each side, for the wording */

    var S = { tub: TUBS.length ? 0 : 'other', colour: 'white', ral: null, ref: '' };

    /* ---------- 1. bath ---------- */
    function cutText(b) {
      var t = (b.len + M) + ' × ' + (b.hgt + M) + ' mm';
      if (C.isL) t += ', return ' + (b.wid + M) + ' mm';
      return t;
    }
    function renderTubs() {
      var box = $('[data-opb-tubs]');
      if (!box) return;
      var name = root.id + '-tub';
      var html = TUBS.map(function (t, i) {
        var col = t.colour.type === 'white' ? 'White' : t.colour.name;
        return '<label class="otb-waste"><input type="radio" name="' + name + '" value="' + i + '"' + (i === 0 ? ' checked' : '') + '>' +
          '<span class="otb-waste__box"><span class="otb-waste__text">' +
          '<span class="otb-waste__name">' + esc(t.title) + '</span>' +
          '<span class="otb-waste__why">In your basket · ' + esc(col) + '</span>' +
          '<span class="otb-waste__from">Panel cut to ' + esc(cutText(t)) + '</span>' +
          '</span></span></label>';
      }).join('');
      html += '<label class="otb-waste"><input type="radio" name="' + name + '" value="other">' +
        '<span class="otb-waste__box"><span class="otb-waste__text">' +
        '<span class="otb-waste__name">A different Omnitub</span>' +
        '<span class="otb-waste__why">One you\'ve already ordered from us. Enter its size.</span>' +
        '</span></span></label>';
      box.innerHTML = html;
      $$('input[name="' + name + '"]').forEach(function (r) {
        r.addEventListener('change', function () { if (r.checked) setTub(r.value === 'other' ? 'other' : +r.value); });
      });
    }
    function curTub() { return typeof S.tub === 'number' ? TUBS[S.tub] : null; }
    function setTub(v) {
      S.tub = v;
      var man = $('[data-opb-manual]');
      if (man) man.hidden = (v !== 'other');
      var t = curTub();
      /* Default colour follows the bath: coloured bath → Match; white bath → White. */
      if (t && t.colour.type !== 'white') setColour('match');
      else if (S.colour === 'match') setColour('white');
      else setColour(S.colour);
      clearError();
      update();
    }
    function bath() {
      var t = curTub();
      if (t) return { len: t.len, wid: t.wid, hgt: t.hgt, ok: true };
      var len = int(($('[data-opb-len]') || {}).value);
      var wid = C.isL ? int(($('[data-opb-wid]') || {}).value) : 0;
      var hgt = int(($('[data-opb-hgt]') || {}).value);
      var ok = len >= LIM.len[0] && len <= LIM.len[1] && hgt >= LIM.hgt[0] && hgt <= LIM.hgt[1] &&
        (!C.isL || (wid >= LIM.wid[0] && wid <= LIM.wid[1]));
      return { len: len, wid: wid, hgt: hgt, ok: ok };
    }
    $$('[data-opb-len],[data-opb-wid],[data-opb-hgt]').forEach(function (el) {
      el.addEventListener('input', function () { clearError(); update(); });
    });

    /* ---------- 2. colour ---------- */
    function setColour(val) {
      var t = curTub();
      var canMatch = !!(t && t.colour.type !== 'white');
      if (val === 'match' && !canMatch) val = 'white';
      if (val === 'custom' && !C.custom) val = 'white';
      S.colour = val;
      var mw = $('[data-opb-match-wrap]');
      if (mw) mw.hidden = !canMatch;
      var grid = $('[data-opb-colours]');
      if (grid) {
        var n = (canMatch ? 1 : 0) + 1 + (C.custom ? 1 : 0);
        grid.classList.toggle('otb-choices--3', n === 3);
        grid.classList.toggle('otb-choices--2', n === 2);
      }
      var wn = $('[data-opb-white-note]');
      if (wn) wn.textContent = (t && t.colour.type === 'white') ? 'Matches your bath' : 'Standard';
      var mh = $('[data-opb-match-help]');
      if (mh) {
        mh.hidden = !(canMatch && val === 'match');
        if (canMatch) mh.textContent = 'Made in the same colour as your bath: ' + t.colour.name + '.';
      }
      $$('input[name$="-colour"]').forEach(function (r) { r.checked = (r.value === val); });
      var ral = $('[data-opb-ral]');
      if (ral) ral.hidden = (val !== 'custom');
      if (val === 'custom') loadColours();
      update();
    }
    $$('input[name$="-colour"]').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) { clearError(); setColour(r.value); } });
    });
    $$('[data-opb-match-price]').forEach(function (el) { el.textContent = '+' + money(C.colourAdd); });

    /* RAL / BS 4800 search — same colour list and licensed swatch sprite as the tub buy box. */
    var COLOURS = null, coloursP = null;
    function loadColours() {
      if (coloursP) return coloursP;
      if (window.OmnSwatch && C.sprite) window.OmnSwatch.cfg(C.sprite, 46, 45);
      coloursP = fetch(C.colours).then(function (r) { return r.json(); }).then(function (d) {
        COLOURS = (d && d.colours) || [];
        renderRal();
        return COLOURS;
      }).catch(function () { coloursP = null; COLOURS = []; });
      return coloursP;
    }
    function colourLabel(c) {
      var code = c.system === 'BS4800' ? 'BS 4800 ' + c.code : c.code;
      var name = String(c.name || '').replace(/\b([a-z])/g, function (m, ch) { return ch.toUpperCase(); });
      return code + (name ? ' ' + name : '');
    }
    function paintChip(el, c) {
      if (!el || !c) return;
      if (c.hex) { el.style.background = c.hex; return; }
      if (window.OmnSwatch && c.si != null) window.OmnSwatch.applyTo(el, c.si);
    }
    function renderRal() {
      var list = $('[data-opb-ral-list]');
      var qEl = $('[data-opb-ral-q]');
      if (!list || !COLOURS) return;
      var q = (qEl && qEl.value || '').trim().toLowerCase();
      list.innerHTML = '';
      if (!q) return;
      var qn = q.replace(/^ral\s*/, '').replace(/^bs\s*4800\s*/, '').replace(/\s+/g, '');
      var hits = COLOURS.filter(function (c) {
        var hay = (c.code + ' ' + c.name + ' ' + (c.system === 'BS4800' ? 'bs 4800 ' + c.code : '')).toLowerCase();
        return hay.indexOf(q) > -1 || hay.replace(/\s+/g, '').indexOf(qn) > -1;
      }).slice(0, 24);
      if (!hits.length) {
        list.innerHTML = '<li class="otb-ral__none">No match. Type the reference in the box below and we\'ll match it.</li>';
        return;
      }
      hits.forEach(function (c) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'otb-ral__opt';
        b.setAttribute('role', 'option');
        b.innerHTML = '<span class="otb-ral__chip"></span><span>' + esc(colourLabel(c)) + '</span>';
        paintChip(b.firstChild, c);
        b.addEventListener('click', function () { pickRal(c); });
        li.appendChild(b);
        list.appendChild(li);
      });
    }
    function pickRal(c) {
      S.ral = c;
      var picked = $('[data-opb-ral-picked]');
      if (picked) {
        picked.hidden = false;
        picked.innerHTML = '<span class="otb-ral__chip"></span><span>' + esc(colourLabel(c)) + '</span>' +
          '<button type="button" class="otb-link" data-opb-ral-clear>Change</button>';
        paintChip(picked.firstChild, c);
        picked.querySelector('[data-opb-ral-clear]').addEventListener('click', function () {
          S.ral = null; picked.hidden = true; picked.innerHTML = '';
          var qEl = $('[data-opb-ral-q]'); if (qEl) qEl.focus();
          update();
        });
      }
      var list = $('[data-opb-ral-list]'); if (list) list.innerHTML = '';
      var qEl = $('[data-opb-ral-q]'); if (qEl) qEl.value = '';
      clearError();
      update();
    }
    var qInput = $('[data-opb-ral-q]');
    if (qInput) {
      var qT;
      qInput.addEventListener('input', function () { clearTimeout(qT); qT = setTimeout(renderRal, 120); });
      qInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
    }
    var refInput = $('[data-opb-ref]');
    if (refInput) refInput.addEventListener('input', function () { S.ref = refInput.value.trim(); clearError(); update(); });

    /* ---------- price + summary ---------- */
    function cut(b) {
      return { len: b.len + M, hgt: b.hgt + M, ret: C.isL ? b.wid + M : 0 };
    }
    function pricePence(b) {
      var c = cut(b);
      var area = (c.len / 1000) * (c.hgt / 1000) + (C.isL ? (c.ret / 1000) * (c.hgt / 1000) : 0);
      /* Same rounding as the Function: £ to the penny. */
      return Math.round(C.base + C.rate * area) + (S.colour === 'white' ? 0 : C.colourAdd);
    }
    function colourName() {
      var t = curTub();
      if (S.colour === 'white') return 'White';
      if (S.colour === 'match' && t) return t.colour.name;
      if (S.ral) return colourLabel(S.ral);
      if (S.ref) return S.ref;
      return 'Custom colour';
    }
    function variant() { return S.colour === 'white' ? C.white : C.custom; }
    /* Matt tub in the basket (same build): the panel is made matt to match. The panel-price Cart
       Transform adds 25% of the panel, rounded UP to the next £5, to the TUB line — mirrored here. */
    function mattTub() { var t = curTub(); return !!(t && t.matt && t.build); }
    function mattFee(pence) { pence = Number(pence) || 0; return pence > 0 ? Math.ceil(Math.round(pence * 0.25) / 500) * 500 : 0; }

    function update() {
      var b = bath();
      var ul = $('[data-opb-lines]');
      var tot = $('[data-opb-total]');
      var shipEl = $('[data-opb-ship]');
      var lines = [];
      var label = KIND_LABEL[C.kind] || 'Bath panel';
      if (b.ok) {
        var p = pricePence(b);
        lines.push('<li><span>' + esc(label + ' · ' + colourName()) + '</span><span>' + money(p) + '</span></li>');
        lines.push('<li><span>Cut to ' + esc(cutText(b)) + ', including ' + MS + ' mm margin each side</span><span></span></li>');
        var mf = mattTub() ? mattFee(p) : 0;
        if (mf) lines.push('<li><span>Matt finish, to match your bath</span><span>' + money(mf) + '</span></li>');
        if (tot) tot.textContent = money(p + mf);
      } else {
        lines.push('<li><span>' + esc(label) + '</span><span>Enter your bath size</span></li>');
        if (tot) tot.textContent = '–';
      }
      if (ul) ul.innerHTML = lines.join('');
      if (shipEl) {
        shipEl.textContent = TUBS.length
          ? 'Inc. VAT. Delivered with your bath at no extra cost.'
          : 'Inc. VAT. UK mainland delivery ' + C.ship + ' when ordered without a bath.';
      }
      var mh2 = $('[data-opb-matt-help]');
      if (mh2) {
        mh2.hidden = !mattTub();
        mh2.textContent = 'Your bath is matt, so we\'ll finish the panel in matt to match. The matt charge is added to your bath in the basket.';
      }
      var v = variant();
      var add = $('[data-opb-add]');
      if (add) {
        var avail = !!(v && v.available);
        add.disabled = !avail;
        add.textContent = avail ? 'Add to basket' : 'Currently unavailable';
      }
    }

    /* ---------- validation + add ---------- */
    function showError(msg, focusEl) {
      var e = $('[data-opb-error]');
      if (e) { e.textContent = msg; e.hidden = false; }
      if (focusEl && focusEl.scrollIntoView) {
        focusEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (focusEl.focus) setTimeout(function () { try { focusEl.focus({ preventScroll: true }); } catch (x) {} }, 300);
      }
    }
    function clearError() { var e = $('[data-opb-error]'); if (e) { e.hidden = true; e.textContent = ''; } }
    function validate() {
      var b = bath();
      if (!b.ok) {
        var lenEl = $('[data-opb-len]'), widEl = $('[data-opb-wid]'), hgtEl = $('[data-opb-hgt]');
        if (!(b.len >= LIM.len[0] && b.len <= LIM.len[1])) {
          showError('Enter your bath\'s length in mm (' + LIM.len[0] + ' to ' + LIM.len[1] + ').', lenEl); return false;
        }
        if (C.isL && !(b.wid >= LIM.wid[0] && b.wid <= LIM.wid[1])) {
          showError('Enter your bath\'s width in mm (' + LIM.wid[0] + ' to ' + LIM.wid[1] + ').', widEl); return false;
        }
        showError('Enter your bath\'s height in mm (' + LIM.hgt[0] + ' to ' + LIM.hgt[1] + ').', hgtEl); return false;
      }
      if (S.colour === 'custom' && !S.ral && !S.ref) {
        showError('Choose a RAL or BS 4800 colour, or type the paint reference you want us to match.', $('[data-opb-ral-q]'));
        return false;
      }
      return true;
    }

    var busy = false;
    function add() {
      if (busy) return;
      clearError();
      if (!validate()) return;
      var v = variant();
      if (!v || !v.available) return;
      var b = bath(), c = cut(b), t = curTub(), price = pricePence(b);

      var props = {};
      if (t) {
        props['For bath'] = t.title;
        props['Bath size'] = t.len + ' × ' + t.wid + ' × ' + t.hgt + ' mm';
      } else {
        props['For bath'] = 'Customer\'s Omnitub (size entered)';
        props['Bath size'] = C.isL ? (b.len + ' × ' + b.wid + ' × ' + b.hgt + ' mm') : (b.len + ' mm long × ' + b.hgt + ' mm tall');
        var ord = (($('[data-opb-order]') || {}).value || '').trim();
        if (ord) props['Order number'] = ord.slice(0, 40);
      }
      props['Cut size'] = cutText(b) + ' (incl. ' + MS + ' mm margin each side)';
      if (S.colour === 'match' && t) {
        props['Requested colour'] = t.colour.name === 'the colour of your bath' ? 'Same as the bath' : t.colour.name;
        if (t.colour.ref) props['Paint reference'] = t.colour.ref;
      } else if (S.colour === 'custom') {
        if (S.ral) { props['Requested colour'] = colourLabel(S.ral); props._colour_code = S.ral.code; }
        if (S.ref) props['Paint reference'] = S.ref;
      }
      props._omn_panel_len = String(c.len);
      props._omn_panel_hgt = String(c.hgt);
      if (C.isL) props._omn_panel_ret = String(c.ret);
      props._omn_panel_kind = C.kind;
      props._omn_panel_price = String(price);
      if (t && t.build) { props._omn_build = t.build; props._omn_addon = '1'; }
      if (mattTub()) props['Finish'] = 'Matt (to match the bath)';   /* money rides the tub line; panel-price ignores Finish on panel lines */

      busy = true;
      var btn = $('[data-opb-add]');
      if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-disabled', 'true'); }

      var drawer = document.querySelector('cart-drawer');
      var sections = ['cart-icon-bubble'];
      var drawerSection = drawer && drawer.closest('.shopify-section') ? drawer.closest('.shopify-section').id.replace('shopify-section-', '') : null;
      if (drawerSection) sections.push(drawerSection);
      var cartAdd = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add';

      fetch(cartAdd + (/\.js$/.test(cartAdd) ? '' : '.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }], sections: sections.join(','), sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            var msg = (res.json && (res.json.description || res.json.message)) || 'Sorry, we couldn\'t add that to your basket. Please try again, or call us.';
            throw new Error(typeof msg === 'string' ? msg : 'Sorry, something went wrong.');
          }
          var data = res.json || {};
          track('panel_add_to_cart', { product: C.product.handle, colour: S.colour, from_basket: !!t });
          try {
            if (data.sections && data.sections['cart-icon-bubble']) {
              var bubble = document.getElementById('cart-icon-bubble');
              if (bubble) bubble.innerHTML = data.sections['cart-icon-bubble'];
            }
          } catch (e) {}
          var afterAtc = window.theme && theme.settings && theme.settings.afterAtc;
          if (afterAtc === 'page' || !drawer) { window.location.href = (window.theme && theme.routes && theme.routes.cart) || '/cart'; return; }
          if (data.sections && drawer.renderContents) drawer.renderContents(data, true);
          else if (drawer.refresh) drawer.refresh(true);
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { cart: cart, variantId: v.id } }));
            }).catch(function () {});
        })
        .catch(function (err) {
          showError((err && err.message) || 'Sorry, something went wrong. Please try again.');
          track('panel_add_error', { product: C.product.handle, error: String(err && err.message || '') });
        })
        .then(function () {
          busy = false;
          if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-disabled'); }
        });
    }
    var addBtn = $('[data-opb-add]');
    if (addBtn) addBtn.addEventListener('click', add);

    renderTubs();
    setTub(S.tub);
  }

  function boot() { document.querySelectorAll('[data-omn-panel-buybox]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  /* The bath list is rendered from the basket; a page restored from the back/forward cache
     may show a stale basket, so reload it. */
  window.addEventListener('pageshow', function (e) { if (e.persisted && document.querySelector('[data-omn-panel-buybox]')) location.reload(); });
})();
